import { useEffect, useState, useRef } from "react";
import api from "./api";

/**
 * Polling ligero del contador de mensajes no leídos.
 * - Refresca al montar, al recobrar foco/visibilidad y cada `intervalMs`.
 * - Si el usuario no está autenticado, devuelve 0 sin pegar al API.
 */
export default function useUnreadMessages(enabled = true, intervalMs = 25000) {
  const [count, setCount] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }
    let mounted = true;
    const fetchCount = async () => {
      try {
        const { data } = await api.get("/messages/unread-count");
        if (mounted) setCount(data?.count || 0);
      } catch {
        /* silencioso: sólo es un badge */
      }
    };
    fetchCount();
    timerRef.current = setInterval(fetchCount, intervalMs);
    const onVisibility = () => { if (document.visibilityState === "visible") fetchCount(); };
    const onFocus = () => fetchCount();
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("focus", onFocus);
    return () => {
      mounted = false;
      clearInterval(timerRef.current);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("focus", onFocus);
    };
  }, [enabled, intervalMs]);

  return count;
}
